import React, { useState, useEffect } from 'react';
import { fetchTrains, fetchTrainDetail, fetchTrainStatus } from '../actions';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import { findTrain, trainHtmlClass, destinationStationName, createTrainSchedule, displayDelay } from '../services/trainsService';
import { eventsEmit } from '../services/appboxService';
import { trainKindClass } from '../data/trainKinds';
import TrainSchedule from './trainDetail/TrainSchedule';
import icTrainTx1000   from '../assets/images/mainline/train/detail/ic_train_tx1000.svg';
import icTrainTx2000   from '../assets/images/mainline/train/detail/ic_train_tx2000.svg';
import icTrainTx2000Zoubi   from '../assets/images/mainline/train/detail/ic_train_tx2000_zoubi.svg';
import icTrainTx3000   from '../assets/images/mainline/train/detail/ic_train_tx3000.svg';
import icTrainTx3000_unir from '../assets/images/mainline/train/detail/ic_train_tx3000_unir.svg';
import icTrainTx20thAkb48 from '../assets/images/mainline/train/detail/ic_train_tx20th_akb48.svg';
import carLocal        from '../assets/images/mainline/train/detail/local.svg';
import carRapid        from '../assets/images/mainline/train/detail/rapid.svg';
import carSemiR        from '../assets/images/mainline/train/detail/semi_r.svg';
import carComR        from '../assets/images/mainline/train/detail/com_r.svg';
import icCloseDialog   from '../assets/images/trains/kinds/ic_close_dialog.svg';

const TrainDetail = () => {
  const [train, setTrain] = useState('');
  const [trainSchedule, setTrainSchedule] = useState('');
  const [displayable, setdisplayable] = useState(false);
  const [trainStatus, setTrainStatus] = useState(0);
  const { train_number } = useParams();

  useEffect(() => {
    import('..//assets/stylesheets/mainline/trains/detail.css')
      .then(() => {
      })
      .catch(err => console.error("CSSの読み込みエラー", err));

    async function fetchTrainDetailJson() {
      try {
        const trainsJson = await fetchTrains();
        const trainData = findTrain(trainsJson.trains, train_number)
        setTrain(trainData);

        const m = moment.tz(trainsJson.updated_at * 1000, 'Asia/Tokyo');
        // 0〜4時の場合は前日扱い
        if (m.hour() >= 0 && m.hour() < 4) {
          m.subtract(1, 'day');
        }
        const trainUpdatedAt = m.format("YYYY-MM-DD");
        const trainDetailJson = await fetchTrainDetail(trainUpdatedAt, train_number);
        console.log(trainDetailJson);

        const trainStatusJson = await fetchTrainStatus();
        const trainStatus = trainStatusJson.category
        // 0 以外は異常
        if (trainStatusJson.category !== 0) {
          setTrainStatus(trainStatusJson.category);
        }

        setTrainSchedule(createTrainSchedule(trainData, trainDetailJson));
        setdisplayable(true);
        eventsEmit('train_detail.screen', { train_number: train_number });
      } catch (error) {
        setdisplayable(true);
        console.error('列車情報の取得に失敗:', error);
      }
    }

    fetchTrainDetailJson();
  }, []);

  const trainIconSvgs = {
    'tx1000': icTrainTx1000,
    'tx2000': icTrainTx2000,
    'tx2000-zoubi': icTrainTx2000Zoubi,
    'tx3000': icTrainTx3000,
    'tx3000-unir': icTrainTx3000_unir,
    'tx20th-akb48': icTrainTx20thAkb48,
  };

  const trainIconSvg = trainIconSvgs[trainHtmlClass(train)] || null;
  const trainIcon = train && trainIconSvg
    ? <img className="train-icon" src={trainIconSvg} alt={`Train ${trainHtmlClass(train)}`} />
    : <div className="train-icon" />;

  const trainKindSvgs = {
    'local': carLocal,
    'com_r': carComR,
    'rapid': carRapid,
    'semi_r': carSemiR,
  };

  const trainKindSvg = () => {
    return trainKindSvgs[trainKindClass(train.train_kind_id)] || null;
  };

  return (
    <div>
      <main className="main-container">
        <div className="modal">
          <div className="modal-window">
            <div className="modal-header">
              {trainIcon}
              <div className="train-detail">
                <div className="detail-container-top">
                  <img
                    src={trainKindSvg()}
                    alt="Car icon"
                  />
                  <span>{train.train_length_id}両</span>
                </div>
                <div className="detail-container-bottom">
                  <p className="train-detail-name">{destinationStationName(train)}</p>
                  <span className="train-destination">行き</span>
                </div>
                <div className="detail-cainainer-delay">
                  {train.delay > 59 && (
                    <p className="train-delay">遅れ約{displayDelay(train.delay)}分</p>
                  )}
                </div>
                <div className="detail-cainainer-delay">
                  {trainStatus !== 0 && (
                    <p className="train-status">現在、発車時刻を表示できません</p>
                  )}
                </div>
              </div>
              <div className="modal-close">
                <a
                  href={`/lines/mainline/trains#train${train_number}`}
                  className="close-button"
                  onClick={(event) => {
                    event.preventDefault();
                    eventsEmit('train_detail.close', {});
                    window.location.href = event.currentTarget.href;
                  }}
                >
                  <img
                    src={icCloseDialog}
                    alt="Close"
                  />
                </a>
              </div>
            </div>
            <div className="train-schedule-wrapper">
              <div className="train-schedule-header">
                <p>停車駅</p>
                {trainStatus === 0 && (
                  <p>（定刻）発車時刻</p>
                )}
              </div>
              <div className="train-schedule-body">
                {!displayable ? null : (
                  trainSchedule.length > 0 ? (
                    <TrainSchedule
                      schedules={trainSchedule}
                      train={train}
                      trainStatus={trainStatus}
                    />
                  ) : (
                    <div class="notice">この列車の停車駅・発車時刻は<br/>表示できません。</div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TrainDetail;
